// import {
//   Modal,
//   Table,
//   Badge,
//   Button,
//   Alert,
//   Text,
//   TextInput,
//   Select,
//   NumberInput,
//   Textarea,
// } from "@mantine/core";
// import { useEffect, useState } from "react";
// import {
//   getUserRequestsAdmin,
//   confirmManualPayment,
//   getPPRPricing,
//   confirmUserFlight,
//   cancelUserFlight,
// } from "../misc/api";
// import {
//   IconCash,
//   IconCheck,
//   IconClock,
//   IconAlertCircle,
// } from "@tabler/icons-react";

// export const AdminRequestSystem = () => {
//   const [elements, setElements] = useState([]);
//   const [refresh, setRefresh] = useState(null);
//   const [paymentModal, setPaymentModal] = useState(null);
//   const [paymentData, setPaymentData] = useState({
//     amount: "",
//     payment_method: "cash",
//     staff_id: "",
//     notes: "",
//   });
//   const [submittingPayment, setSubmittingPayment] = useState(false);

//   useEffect(() => {
//     getUserRequestsAdmin().then((x) => {
//       setElements(x);
//     });
//   }, [refresh]);

//   const handleConfirmPayment = async () => {
//     if (!paymentData.amount || !paymentModal.ppr_number) {
//       alert("Please fill in all required fields");
//       return;
//     }

//     setSubmittingPayment(true);
//     try {
//       const response = await confirmManualPayment(
//         paymentModal.ppr_number,
//         paymentData.amount,
//         paymentData.payment_method,
//         paymentData.staff_id,
//         paymentData.notes
//       );

//       if (response.message) {
//         alert("Payment confirmed successfully!");
//         setPaymentModal(null);
//         setPaymentData({
//           amount: "",
//           payment_method: "cash",
//           staff_id: "",
//           notes: "",
//         });
//         setRefresh(Date.now()); // Trigger refresh
//       } else {
//         alert("Error confirming payment");
//       }
//     } catch (error) {
//       console.error("Payment confirmation error:", error);
//       alert("Error confirming payment: " + error.message);
//     } finally {
//       setSubmittingPayment(false);
//     }
//   };

//   const openPaymentModal = async (request) => {
//     setPaymentModal(request);

//     // Try to get suggested pricing
//     if (request.flight_type) {
//       try {
//         const pricing = await getPPRPricing(request.flight_type, "one_time");
//         setPaymentData((prev) => ({
//           ...prev,
//           amount: pricing?.price?.toString(),
//         }));
//       } catch (error) { }
//     }
//   };

//   const getPaymentStatusBadge = (request) => {
//     if (request.status == "cancelled") {
//       return;
//     }

//     if (
//       (request.payment_type === "cashier" ||
//         request.payment_type === "airport") && request.ppr_info?.payment_status !== "paid"
//     ) {
//       return (
//         <Badge color="orange" leftSection={<IconCash size="0.8rem" />}>
//           Pay at Airport
//         </Badge>
//       );
//     }

//     if (request.ppr_info?.payment_status === "paid") {
//       if (request.payment_type === "cashier" ||
//         request.payment_type === "airport") {
//         return (<Badge color="green" leftSection={<IconCheck size="0.8rem" />}>
//           Paid at airport
//         </Badge>)
//       }
//       return (
//         <Badge color="green" leftSection={<IconCheck size="0.8rem" />}>
//           Paid Online
//         </Badge>
//       );
//     }

//     if (request.ppr_info?.needs_payment) {
//       return (
//         <Badge color="red" leftSection={<IconClock size="0.8rem" />}>
//           Payment Pending
//         </Badge>
//       );
//     }

//     return <Badge color="gray">Unknown</Badge>;
//   };

//   const canConfirmPayment = (request) => {
//     return (
//       (request.payment_type === "airport" ||
//         request.payment_type === "cashier") &&
//       request.ppr_info?.payment_status !== "paid" &&
//       request.status !== "cancelled"
//     );
//   };

//   // Enhanced FlightRows component specifically for admin
//   const AdminFlightRows = ({ elements, setRefresh }) => {
//     const [modal, setModal] = useState(null);

//     const confirmFlight = (id) => {
//       if (window.confirm("Are you sure you want to confirm this request?")) {
//         confirmUserFlight({ id: id });
//         setModal(null);
//         setRefresh && setRefresh(id);
//       }
//     };

//     const declineFlight = (id) => {
//       if (window.confirm("Are you sure you want to decline this request?")) {
//         cancelUserFlight({ id: id });
//         setModal(null);
//         setRefresh && setRefresh(id);
//       }
//     };

//     const rows = elements?.data?.map((element, index) => (
//       <tr
//         key={index}
//         onClick={() => setModal(element)}
//         style={{
//           cursor: "pointer",
//           backgroundColor:
//             element.status == "confirmed" || element.status == "approved"
//               ? "#00800020"
//               : element.status == "cancelled"
//                 ? "#ff000020"
//                 : "",
//         }}
//       >
//         <td>{index + 1}</td>
//         <td>
//           {element.requester_email || element.email || ""}
//           <br />
//           <small style={{ color: "#666" }}>
//             {element.requester_number || element.phone || ""}
//           </small>
//         </td>
//         <td>{element.departure_place}</td>
//         <td>{element.arrival_place}</td>
//         <td>{element.dof ? new Date(element.dof).toLocaleDateString() : ""}</td>
//         <td>{element.departure_time}</td>
//         <td>
//           <Badge
//             color={
//               element.status == "confirmed" || element.status == "approved"
//                 ? "green"
//                 : element?.status == "cancelled"
//                   ? "red"
//                   : "orange"
//             }
//           >
//             {element.status}
//           </Badge>
//         </td>
//         <td>
//           {element.ppr_number && (
//             <div>
//               <Badge color="blue">PPR {element.ppr_number}</Badge>
//               <div style={{ fontSize: "10px", marginTop: "2px" }}>
//                 {element.ppr_info?.flight_type || "single_day"}
//               </div>
//             </div>
//           )}
//         </td>
//         <td>
//           <div
//             style={{
//               display: "flex",
//               flexDirection: "column",
//               gap: "4px",
//               alignItems: "center",
//             }}
//           >
//             {getPaymentStatusBadge(element)}
//             {canConfirmPayment(element) && (
//               <Button
//                 size="xs"
//                 color="green"
//                 onClick={(e) => {
//                   e.stopPropagation();
//                   openPaymentModal(element);
//                 }}
//               >
//                 Confirm Payment
//               </Button>
//             )}
//           </div>
//         </td>
//       </tr>
//     ));

//     return (
//       <>
//         <Modal
//           opened={modal}
//           onClose={() => setModal(null)}
//           title="Flight Request Details"
//           size="lg"
//         >
//           {modal && (
//             <div>
//               <div
//                 style={{
//                   display: "flex",
//                   justifyContent: "space-between",
//                   marginBottom: 20,
//                 }}
//               >
//                 <div>
//                   <Text weight={600}>Flight Information</Text>
//                   <Text size="sm">
//                     DOF: {new Date(modal.dof).toLocaleDateString()}
//                   </Text>
//                   <Text size="sm">
//                     {modal.departure_place} → {modal.arrival_place}
//                   </Text>
//                   <Text size="sm">Departure: {modal.departure_time}</Text>
//                   <Text size="sm">Duration: {modal.flight_lenght}</Text>
//                 </div>
//                 <div>
//                   <Badge
//                     color={
//                       modal.status == "confirmed" || modal.status == "approved"
//                         ? "green"
//                         : modal.status == "cancelled"
//                           ? "red"
//                           : "orange"
//                     }
//                   >
//                     {modal.status}
//                   </Badge>
//                 </div>
//               </div>

//               {modal.ppr_number && (
//                 <div style={{ marginBottom: 20 }}>
//                   <Text weight={600}>PPR Information</Text>
//                   <Text size="sm">PPR Number: {modal.ppr_number}</Text>
//                   <Text size="sm">
//                     Type: {modal.ppr_info?.type} ({modal.ppr_info?.flight_type})
//                   </Text>
//                   <Text size="sm">Status: {modal.ppr_info?.status}</Text>
//                   {modal.ppr_info?.expires_at && (
//                     <Text size="sm">
//                       Expires:{" "}
//                       {new Date(modal.ppr_info.expires_at).toLocaleDateString()}
//                     </Text>
//                   )}
//                 </div>
//               )}

//               <div style={{ marginBottom: 20 }}>
//                 <Text weight={600}>Payment Status</Text>
//                 {getPaymentStatusBadge(modal)}
//                 {modal.ppr_info?.payment_amount && (
//                   <Text size="sm">
//                     Amount: €{modal.ppr_info.payment_amount}
//                   </Text>
//                 )}
//               </div>

//               <div style={{ marginBottom: 20 }}>
//                 <Text weight={600}>Contact Information</Text>
//                 <Text size="sm">
//                   Email: {modal.requester_email || modal.email}
//                 </Text>
//                 <Text size="sm">
//                   Phone: {modal.requester_number || modal.phone}
//                 </Text>
//               </div>

//               {canConfirmPayment(modal) && (
//                 <div style={{ marginTop: 20 }}>
//                   <Button color="green" onClick={() => openPaymentModal(modal)}>
//                     Confirm Payment
//                   </Button>
//                 </div>
//               )}
//             </div>
//           )}
//           {modal && modal?.status == "pending" && (
//             <div
//               style={{
//                 justifyContent: "space-between",
//                 display: "flex",
//                 marginTop: 20,
//               }}
//             >
//               <Button
//                 onClick={() => confirmFlight(modal && modal.request_id)}
//                 style={{ backgroundColor: "green" }}
//               >
//                 Confirm flight
//               </Button>{" "}
//               <Button
//                 onClick={() => declineFlight(modal && modal.request_id)}
//                 style={{ backgroundColor: "red" }}
//               >
//                 Decline flight
//               </Button>
//             </div>
//           )}
//         </Modal>

//         <Table style={{ textAlign: "center" }}>
//           <thead>
//             <tr>
//               <th>Nr.</th>
//               <th>Contact</th>
//               <th>From</th>
//               <th>To</th>
//               <th>Date</th>
//               <th>Time</th>
//               <th>Status</th>
//               <th>PPR</th>
//               <th>Payment</th>
//             </tr>
//           </thead>
//           <tbody>{elements && !elements.error && rows}</tbody>
//         </Table>
//       </>
//     );
//   };

//   return (
//     <>
//       <Modal
//         opened={paymentModal}
//         onClose={() => setPaymentModal(null)}
//         title="Confirm Manual Payment"
//         centered
//       >
//         {paymentModal && (
//           <div>
//             <Alert icon={<IconAlertCircle size="1rem" />} color="blue" mb="md">
//               <Text size="sm">
//                 <strong>PPR {paymentModal.ppr_number}</strong> - Confirming
//                 payment for {paymentModal.requester_email || paymentModal.email}
//               </Text>
//             </Alert>

//             <NumberInput
//               label="Payment Amount (EUR)"
//               placeholder="25.00"
//               value={paymentData.amount}
//               onChange={(value) =>
//                 setPaymentData((prev) => ({
//                   ...prev,
//                   amount: value?.toString() || "",
//                 }))
//               }
//               precision={2}
//               min={0}
//               step={0.01}
//               required
//               mb="sm"
//             />

//             <Select
//               label="Payment Method"
//               value={paymentData.payment_method}
//               onChange={(value) =>
//                 setPaymentData((prev) => ({ ...prev, payment_method: value }))
//               }
//               data={[
//                 { value: "cash", label: "Cash" },
//                 { value: "card", label: "Card" },
//                 { value: "bank_transfer", label: "Bank Transfer" },
//                 { value: "other", label: "Other" },
//               ]}
//               mb="sm"
//             />

//             <TextInput
//               label="Staff ID / Name"
//               placeholder="Your staff ID or name"
//               value={paymentData.staff_id}
//               onChange={(event) =>
//                 setPaymentData((prev) => ({
//                   ...prev,
//                   staff_id: event.target.value,
//                 }))
//               }
//               mb="sm"
//             />

//             <Textarea
//               label="Notes (optional)"
//               placeholder="Any additional notes about the payment"
//               value={paymentData.notes}
//               onChange={(event) =>
//                 setPaymentData((prev) => ({
//                   ...prev,
//                   notes: event.target.value,
//                 }))
//               }
//               rows={3}
//               mb="md"
//             />

//             <div style={{ display: "flex", justifyContent: "space-between" }}>
//               <Button variant="outline" onClick={() => setPaymentModal(null)}>
//                 Cancel
//               </Button>
//               <Button
//                 color="green"
//                 onClick={handleConfirmPayment}
//                 loading={submittingPayment}
//               >
//                 Confirm Payment
//               </Button>
//             </div>
//           </div>
//         )}
//       </Modal>

//       <h3>Flight Requests</h3>
//       {!elements.error && (
//         <AdminFlightRows
//           elements={elements && !elements.error && elements}
//           setRefresh={setRefresh}
//         />
//       )}
//     </>
//   );
// };

import {
  Modal,
  Table,
  Badge,
  Button,
  Alert,
  Text,
  TextInput,
  Select,
  NumberInput,
  Textarea,
  Group,
  Pagination,
  Paper,
  Grid,
} from "@mantine/core";
import { useEffect, useState } from "react";
import { DateInput } from "@mantine/dates";
import {
  getUserRequestsAdmin,
  confirmManualPayment,
  getPPRPricing,
  confirmUserFlight,
  cancelUserFlight,
} from "../misc/api";
import {
  IconCash,
  IconCheck,
  IconClock,
  IconAlertCircle,
  IconSearch,
  IconX,
} from "@tabler/icons-react";

export const AdminRequestSystem = () => {
  const [elements, setElements] = useState([]);
  const [refresh, setRefresh] = useState(null);
  const [paymentModal, setPaymentModal] = useState(null);
  const [paymentData, setPaymentData] = useState({
    amount: "",
    payment_method: "cash",
    staff_id: "",
    notes: "",
  });
  const [submittingPayment, setSubmittingPayment] = useState(false);

  // Pagination & Filter states
  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage] = useState(20);
  const [filters, setFilters] = useState({
    status: "",
    paymentStatus: "",
    pprStatus: "",
    dateFrom: null,
    dateTo: null,
    searchText: "",
  });

  useEffect(() => {
    getUserRequestsAdmin().then((x) => {
      setElements(x);
    });
  }, [refresh]);

  const handleConfirmPayment = async () => {
    if (!paymentData.amount || !paymentModal.ppr_number) {
      alert("Please fill in all required fields");
      return;
    }

    setSubmittingPayment(true);
    try {
      const response = await confirmManualPayment(
        paymentModal.ppr_number,
        paymentData.amount,
        paymentData.payment_method,
        paymentData.staff_id,
        paymentData.notes
      );

      if (response.message) {
        alert("Payment confirmed successfully!");
        setPaymentModal(null);
        setPaymentData({
          amount: "",
          payment_method: "cash",
          staff_id: "",
          notes: "",
        });
        setRefresh(Date.now());
      } else {
        alert("Error confirming payment");
      }
    } catch (error) {
      console.error("Payment confirmation error:", error);
      alert("Error confirming payment: " + error.message);
    } finally {
      setSubmittingPayment(false);
    }
  };

  const openPaymentModal = async (request) => {
    setPaymentModal(request);

    if (request.flight_type) {
      try {
        const pricing = await getPPRPricing(request.flight_type, "one_time");
        setPaymentData((prev) => ({
          ...prev,
          amount: pricing?.price?.toString(),
        }));
      } catch (error) { }
    }
  };

  const getPaymentStatusBadge = (request) => {
    if (request.status == "cancelled") {
      return;
    }

    if (
      (request.payment_type === "cashier" || request.payment_type === "airport") &&
      request.ppr_info?.payment_status !== "paid"
    ) {
      return (
        <Badge color="orange" leftSection={<IconCash size="0.8rem" />}>
          Pay at Airport
        </Badge>
      );
    }

    if (request.ppr_info?.payment_status === "paid") {
      if (request.payment_type === "cashier" || request.payment_type === "airport") {
        return (
          <Badge color="green" leftSection={<IconCheck size="0.8rem" />}>
            Paid at airport
          </Badge>
        );
      }
      return (
        <Badge color="green" leftSection={<IconCheck size="0.8rem" />}>
          Paid Online
        </Badge>
      );
    }

    if (request.ppr_info?.needs_payment) {
      return (
        <Badge color="red" leftSection={<IconClock size="0.8rem" />}>
          Payment Pending
        </Badge>
      );
    }

    return <Badge color="gray">Unknown</Badge>;
  };

  const canConfirmPayment = (request) => {
    return (
      // (request.payment_type === "airport" || request.payment_type === "cashier") &&
      request.ppr_info?.payment_status !== "paid" &&
      request.status !== "cancelled"
    );
  };

  // Filter logic
  const applyFilters = (data) => {
    if (!data || !Array.isArray(data)) return [];

    return data.filter((item) => {
      // Status filter
      if (filters.status && item.status !== filters.status) return false;

      // Payment status filter
      if (filters.paymentStatus) {
        if (filters.paymentStatus === "paid" && item.ppr_info?.payment_status !== "paid")
          return false;
        if (filters.paymentStatus === "pending" && item.ppr_info?.payment_status === "paid")
          return false;
      }

      // PPR status filter
      if (filters.pprStatus === "has_ppr" && !item.ppr_number) return false;
      if (filters.pprStatus === "no_ppr" && item.ppr_number) return false;

      // Date range filter
      if (filters.dateFrom) {
        const itemDate = new Date(item.dof);
        if (itemDate < filters.dateFrom) return false;
      }
      if (filters.dateTo) {
        const itemDate = new Date(item.dof);
        if (itemDate > filters.dateTo) return false;
      }

      // Search text filter
      if (filters.searchText) {
        const searchLower = filters.searchText.toLowerCase();
        const matchesEmail = (item.requester_email || item.email || "")
          .toLowerCase()
          .includes(searchLower);
        const matchesPhone = (item.requester_number || item.phone || "")
          .toLowerCase()
          .includes(searchLower);
        const matchesPPR = (item.ppr_number || "").toLowerCase().includes(searchLower);
        const matchesPlaces =
          (item.departure_place || "").toLowerCase().includes(searchLower) ||
          (item.arrival_place || "").toLowerCase().includes(searchLower);

        if (!matchesEmail && !matchesPhone && !matchesPPR && !matchesPlaces) return false;
      }

      return true;
    });
  };

  const filteredData = applyFilters(elements?.data || []);
  const totalPages = Math.ceil(filteredData.length / itemsPerPage);
  const paginatedData = filteredData.slice(
    (currentPage - 1) * itemsPerPage,
    currentPage * itemsPerPage
  );

  const clearFilters = () => {
    setFilters({
      status: "",
      paymentStatus: "",
      pprStatus: "",
      dateFrom: null,
      dateTo: null,
      searchText: "",
    });
    setCurrentPage(1);
  };

  // Enhanced FlightRows component
  const AdminFlightRows = ({ elements, setRefresh }) => {
    const [modal, setModal] = useState(null);

    const confirmFlight = (id) => {
      if (window.confirm("Are you sure you want to confirm this request?")) {
        confirmUserFlight({ id: id });
        setModal(null);
        setRefresh && setRefresh(id);
      }
    };

    const declineFlight = (id) => {
      if (window.confirm("Are you sure you want to decline this request?")) {
        cancelUserFlight({ id: id });
        setModal(null);
        setRefresh && setRefresh(id);
      }
    };

    const rows = elements?.map((element, index) => (
      <tr
        key={index}
        onClick={() => setModal(element)}
        style={{
          cursor: "pointer",
          backgroundColor:
            element.status == "confirmed" || element.status == "approved"
              ? "#00800020"
              : element.status == "cancelled"
                ? "#ff000020"
                : "",
        }}
      >
        <td>{(currentPage - 1) * itemsPerPage + index + 1}</td>
        <td>
          {element.requester_email || element.email || ""}
          <br />
          <small style={{ color: "#666" }}>
            {element.requester_number || element.phone || ""}
          </small>
        </td>
        <td>{element.departure_place}</td>
        <td>{element.arrival_place}</td>
        <td>{element.dof ? new Date(element.dof).toLocaleDateString() : ""}</td>
        <td>{element.departure_time}</td>
        <td>
          <Badge
            color={
              element.status == "confirmed" || element.status == "approved"
                ? "green"
                : element?.status == "cancelled"
                  ? "red"
                  : "orange"
            }
          >
            {element.status}
          </Badge>
        </td>
        <td>
          {element.ppr_number && (
            <div>
              <Badge color="blue">PPR {element.ppr_number}</Badge>
              <div style={{ fontSize: "10px", marginTop: "2px" }}>
                {element.ppr_info?.flight_type || "single_day"}
              </div>
            </div>
          )}
        </td>
        <td>
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              gap: "4px",
              alignItems: "center",
            }}
          >
            {getPaymentStatusBadge(element)}
            {/* {canConfirmPayment(element) && (
              <Button
                size="xs"
                style={{height: 25}}
                color="green"
                onClick={(e) => {
                  e.stopPropagation();
                  openPaymentModal(element);
                }}
              >
                Confirm Payment
              </Button>
            )} */}
          </div>
        </td>
      </tr>
    ));

    return (
      <>
        <Modal
          opened={modal}
          onClose={() => setModal(null)}
          title="Flight Request Details"
          size="lg"
        >
          {modal && (
            <div>
              <div
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  marginBottom: 20,
                }}
              >
                <div>
                  <Text weight={600}>Flight Information</Text>
                  <Text size="sm">DOF: {new Date(modal.dof).toLocaleDateString()}</Text>
                  <Text size="sm">
                    {modal.departure_place} → {modal.arrival_place}
                  </Text>
                  <Text size="sm">Departure: {modal.departure_time}</Text>
                  <Text size="sm">Duration: {modal.flight_lenght}</Text>
                </div>
                <div>
                  <Badge
                    color={
                      modal.status == "confirmed" || modal.status == "approved"
                        ? "green"
                        : modal.status == "cancelled"
                          ? "red"
                          : "orange"
                    }
                  >
                    {modal.status}
                  </Badge>
                </div>
              </div>

              {modal.ppr_number && (
                <div style={{ marginBottom: 20 }}>
                  <Text weight={600}>PPR Information</Text>
                  <Text size="sm">PPR Number: {modal.ppr_number}</Text>
                  <Text size="sm">
                    Type: {modal.ppr_info?.type} ({modal.ppr_info?.flight_type})
                  </Text>
                  <Text size="sm">Status: {modal.ppr_info?.status}</Text>
                  {modal.ppr_info?.expires_at && (
                    <Text size="sm">
                      Expires: {new Date(modal.ppr_info.expires_at).toLocaleDateString()}
                    </Text>
                  )}
                </div>
              )}

              <div style={{ marginBottom: 20 }}>
                <Text weight={600}>Payment Status</Text>
                {getPaymentStatusBadge(modal)}
                {modal.ppr_info?.payment_amount && (
                  <Text size="sm">Amount: €{modal.ppr_info.payment_amount}</Text>
                )}
              </div>

              <div style={{ marginBottom: 20 }}>
                <Text weight={600}>Contact Information</Text>
                <Text size="sm">Email: {modal.requester_email || modal.email}</Text>
                <Text size="sm">Phone: {modal.requester_number || modal.phone}</Text>
              </div>

              {canConfirmPayment(modal) && (
                <div style={{ marginTop: 20 }}>
                  <Button color="green" onClick={() => openPaymentModal(modal)}>
                    Confirm Payment
                  </Button>
                </div>
              )}
            </div>
          )}
          {modal && modal?.status == "pending" && (
            <div
              style={{
                justifyContent: "space-between",
                display: "flex",
                marginTop: 20,
              }}
            >
              <Button
                onClick={() => confirmFlight(modal && modal.request_id)}
                style={{ backgroundColor: "green" }}
              >
                Confirm flight
              </Button>{" "}
              <Button
                onClick={() => declineFlight(modal && modal.request_id)}
                style={{ backgroundColor: "red" }}
              >
                Decline flight
              </Button>
            </div>
          )}
        </Modal>

        <Table style={{ textAlign: "center" }}>
          <thead>
            <tr>
              <th>Nr.</th>
              <th>Contact</th>
              <th>From</th>
              <th>To</th>
              <th>Date</th>
              <th>Time</th>
              <th>Status</th>
              <th>PPR</th>
              <th>Payment</th>
            </tr>
          </thead>
          <tbody>{elements && rows}</tbody>
        </Table>
      </>
    );
  };

  return (
    <>
      <Modal
        opened={paymentModal}
        onClose={() => setPaymentModal(null)}
        title="Confirm Manual Payment"
        centered
      >
        {paymentModal && (
          <div>
            <Alert icon={<IconAlertCircle size="1rem" />} color="blue" mb="md">
              <Text size="sm">
                <strong>PPR {paymentModal.ppr_number}</strong> - Confirming payment for{" "}
                {paymentModal.requester_email || paymentModal.email}
              </Text>
            </Alert>

            <NumberInput
              label="Payment Amount (EUR)"
              placeholder="25.00"
              value={paymentData.amount}
              onChange={(value) =>
                setPaymentData((prev) => ({
                  ...prev,
                  amount: value?.toString() || "",
                }))
              }
              precision={2}
              min={0}
              step={0.01}
              required
              mb="sm"
            />

            <Select
              label="Payment Method"
              value={paymentData.payment_method}
              onChange={(value) =>
                setPaymentData((prev) => ({ ...prev, payment_method: value }))
              }
              data={[
                { value: "cash", label: "Cash" },
                { value: "card", label: "Card" },
                { value: "bank_transfer", label: "Bank Transfer" },
                { value: "other", label: "Other" },
              ]}
              mb="sm"
            />

            <TextInput
              label="Staff ID / Name"
              placeholder="Your staff ID or name"
              value={paymentData.staff_id}
              onChange={(event) =>
                setPaymentData((prev) => ({
                  ...prev,
                  staff_id: event.target.value,
                }))
              }
              mb="sm"
            />

            <Textarea
              label="Notes (optional)"
              placeholder="Any additional notes about the payment"
              value={paymentData.notes}
              onChange={(event) =>
                setPaymentData((prev) => ({
                  ...prev,
                  notes: event.target.value,
                }))
              }
              rows={3}
              mb="md"
            />

            <div style={{ display: "flex", justifyContent: "space-between" }}>
              <Button variant="outline" onClick={() => setPaymentModal(null)}>
                Cancel
              </Button>
              <Button color="green" onClick={handleConfirmPayment} loading={submittingPayment}>
                Confirm Payment
              </Button>
            </div>
          </div>
        )}
      </Modal>

      {/* Filter Section */}
      <Paper p="md" mb="md" withBorder>
        <Group position="apart" mb="sm">
          <Text weight={600} size="lg">
            Meklēšanas filtri
          </Text>
          <Button
            variant="subtle"
            color="red"
            leftIcon={<IconX size={16} />}
            onClick={clearFilters}
          >
            Notīrīt filtrus
          </Button>
        </Group>

        <Grid>
          <Grid.Col span={6}>
            <TextInput
              label="Meklēt"
              placeholder="E-pasts, tālrunis, PPR, vieta..."
              icon={<IconSearch size={16} />}
              value={filters.searchText}
              onChange={(e) => setFilters({ ...filters, searchText: e.target.value })}
            />
          </Grid.Col>

          <Grid.Col span={3}>
            <Select
              label="Statuss"
              placeholder="Visi"
              clearable
              value={filters.status}
              onChange={(value) => setFilters({ ...filters, status: value || "" })}
              data={[
                { value: "pending", label: "Gaida" },
                { value: "confirmed", label: "Apstiprināts" },
                { value: "approved", label: "Apstiprināts" },
                { value: "cancelled", label: "Atcelts" },
              ]}
            />
          </Grid.Col>

          <Grid.Col span={3}>
            <Select
              label="Maksājuma statuss"
              placeholder="Visi"
              clearable
              value={filters.paymentStatus}
              onChange={(value) => setFilters({ ...filters, paymentStatus: value || "" })}
              data={[
                { value: "paid", label: "Samaksāts" },
                { value: "pending", label: "Gaida maksājumu" },
              ]}
            />
          </Grid.Col>

          <Grid.Col span={3}>
            <Select
              label="PPR statuss"
              placeholder="Visi"
              clearable
              value={filters.pprStatus}
              onChange={(value) => setFilters({ ...filters, pprStatus: value || "" })}
              data={[
                { value: "has_ppr", label: "Ar PPR" },
                { value: "no_ppr", label: "Bez PPR" },
              ]}
            />
          </Grid.Col>

          <Grid.Col span={3}>
            <DateInput
              label="Datums no"
              placeholder="Izvēlēties datumu"
              clearable
              value={filters.dateFrom}
              onChange={(value) => setFilters({ ...filters, dateFrom: value })}
            />
          </Grid.Col>

          <Grid.Col span={3}>
            <DateInput
              label="Datums līdz"
              placeholder="Izvēlēties datumu"
              clearable
              value={filters.dateTo}
              onChange={(value) => setFilters({ ...filters, dateTo: value })}
            />
          </Grid.Col>
        </Grid>

        <Group position="apart" mt="md">
          <Text size="sm" color="dimmed">
            Atrasti: {filteredData.length} no {elements?.data?.length || 0} ierakstiem
          </Text>
        </Group>
      </Paper>

      <h3>Lidojumu pieprasījumi</h3>
      {!elements.error && <AdminFlightRows elements={paginatedData} setRefresh={setRefresh} />}

      {/* Pagination */}
      {totalPages > 1 && (
        <Group position="center" mt="xl">
          <Pagination
            value={currentPage}
            onChange={setCurrentPage}
            total={totalPages}
            size="lg"
          />
        </Group>
      )}
    </>
  );
};